import { Box, Image } from "components/base";
import { Flex } from "components/base/container";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { FAUCET_URL, MODULE_ADDR, NODE_URL } from "config";

import { SnorePoolList, PoolInfo } from "utils/types";
import { WalletClient } from "@martiandao/aptos-web3-bip44.js";
import Loading from "components/element/element.loading";

interface StakedCollectionInfo {
  collection_name: string;
  pool_id: string;
  collection_img_url: string;
}
export const StakedNftColections = () => {
  const navigate = useNavigate();
  const [stakedCollections, setStakedCollections] = useState<StakedCollectionInfo[]>([]);
  const [apis] = useState(new WalletClient(NODE_URL, FAUCET_URL));

  useEffect(() => {
    initialize();
  }, [apis]);

  const initialize = async () => {
    let resource = await apis.getAccountResource(MODULE_ADDR, `${MODULE_ADDR}::snore::SnorePoolList`);
    if (!resource) {
      return;
    }

    const snore_pool_list = resource?.data as SnorePoolList;
    let pool_id_list = snore_pool_list.pool_id_list;
    let staked_collections: StakedCollectionInfo[] = [];

    for (let i = 0; i < pool_id_list.length; i++) {
      let pool_info: PoolInfo = await apis.getCustomResource(
        MODULE_ADDR,
        `${MODULE_ADDR}::snore::SnorePoolList`,
        "pool_table",
        "u64",
        `${MODULE_ADDR}::snore::SnorePool`,
        pool_id_list[i]
      );
      if (pool_info.is_start) {
        staked_collections.push({
          collection_name: pool_info.collection_name,
          pool_id: pool_id_list[i],
          collection_img_url: pool_info.collection_img_url,
        });
      }
    }
    setStakedCollections(staked_collections);
  };
  return (
    <Box
      display={"grid"}
      gridTemplateColumns={["1fr", "1fr", "1fr 1fr", "1fr 1fr 1fr"]}
      pt={["30px", "30px", "60px"]}
      gridGap={"24px"}
      justifyItems={"center"}
    >
      <Loading gridColumn={["1 / span 1", "1 / span 1", "1 / span 2", "1 / span 3"]} py={"30px"} loading={stakedCollections.length === 0} />
      {stakedCollections.map((collectionInfo,index) => {
        return (
          <CollectionCard
              key = {`collection_card_${index}`}
            collection={collectionInfo}
            onClick={() => {
              navigate(`/detail/${collectionInfo.pool_id}`);
            }}
          />
        );
      })}
    </Box>
  );
};

interface CollectionCardProps {
  collection: StakedCollectionInfo;
  onClick: any;
}
export const CollectionCard: React.FC<CollectionCardProps> = ({ collection, onClick }) => {
  return (
    <CollectionCardBase onClick={onClick} cursor={"pointer"}>
      <Image src={collection.collection_img_url} width={"100%"} />
      <Flex position={"absolute"} background={"linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 78.74%)"} width={"100%"} height={"100%"} />
      <Flex position={"absolute"} bottom={"0px"} width={"100%"} col p={"16px 14px"}>
        <Flex color={"white"} fontWeight={"700"} fontSize={"32px"} lineHeight={"100%"}>
          {collection.collection_name}
        </Flex>
      </Flex>
    </CollectionCardBase>
  );
};

const CollectionCardBase = styled(Flex)``;
CollectionCardBase.defaultProps = {
  position: "relative",
  width: ["322px", "322px", "341px", "360px"],
  borderRadius: "16px",
  overflow: "hidden",
};
